import { useState, useEffect } from 'react'
import { unFormatNumber } from '../../helpers/commonHelpers'

const AnimatedNumber = ({ start, end, duration = 2000 }) => {
  const [value, setValue] = useState(start)

  useEffect(() => {
    let startTime
    let animationFrame

    const updateNumber = (timestamp) => {
      if (!startTime) startTime = timestamp
      const progress = Math.min((timestamp - startTime) / duration, 1)
      setValue(Math.floor(progress * (unFormatNumber(end) - unFormatNumber(start)) + unFormatNumber(start)))
      if (progress < 1) {
        animationFrame = requestAnimationFrame(updateNumber)
      }
    }

    animationFrame = requestAnimationFrame(updateNumber)

    return () => cancelAnimationFrame(animationFrame)
  }, [start, end, duration])

  return value.toLocaleString()
}

export default AnimatedNumber
